export default __webpack_public_path__ + "static/media/benefits_carousel.a0e63214.mp4";